import { ProjectTask } from './../../_models/project-task.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { catchError, retry } from 'rxjs/operators';
import { DataStateChangeEventArgs, DataSourceChangedEventArgs } from '@syncfusion/ej2-angular-grids';
import { map } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';

@Injectable({
  providedIn: 'root'
})
export class TaskService extends Subject<DataStateChangeEventArgs>{

  constructor(private http: HttpClient) {
    super();
  }

  handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }

 //Get All Project tasks
getAllProjectTasks(projectId): Observable<Object> {
  let params = new HttpParams();
  //params = params.append('filterBy', 'projectId');
  params = params.append('projectId', projectId);
  return this.http.get(`${environment.apiUrl}/projectTasks`, { params: params }).pipe(catchError(this.handleError));
}

// Get ProjectTaskss by Id Get
getProjectTasksById(id: number): Observable<Object> {
  return this.http.get(`${environment.apiUrl}/projectTasks/${id}`).pipe(catchError(this.handleError));
}

// Create ProjectTasks
createProjectTasks(data: Object): Observable<Object> {
  console.log("In createContact method, ProjectTasks: ", data);
  return this.http.post(`${environment.apiUrl}/projectTasks`, data).pipe(catchError(this.handleError));
}

// Create ProjectTasks
createBulkProjectTasks(data: Object): Observable<Object> {
  console.log("In createContact method, ProjectTasks: ", data);
  return this.http.post(`${environment.apiUrl}/bulkProjectTasks`, data).pipe(catchError(this.handleError));
}

//Delete Project by Id Delete
  deleteProjectTasks(id: number): Observable<Object> {
  return this.http.delete(`${environment.apiUrl}/projectTasks/${id}`).pipe(catchError(this.handleError));
}

 //Update Project by Id Put
  updateProjectTasks(user: Object,id: number): Observable<Object> {
  console.log("In createProjectTasks method, user: ", user);
  return this.http.put(`${environment.apiUrl}/projectTasks/${id}`, user).pipe(catchError(this.handleError));
}

   //Synfusion  CRUD Operation
   public execute(state: any): void {
    console.log("Execute ProjectTasks funtion", state);
    console.log("Execute Return Statement", this.getAllData(state).subscribe(x => super.next(x as DataStateChangeEventArgs)));
    this.getAllData(state).subscribe(x => super.next(x as DataStateChangeEventArgs));
  }

    /** GET all data from the server */
    getAllData(state?: any): Observable<any[]> {
      console.log("GetAllData ProjectTasks",this.http.get<ProjectTask[]>(`${environment.apiUrl}/projectTasks`).pipe(retry(2), catchError(this.handleError)));
      return this.http.get<ProjectTask[]>(`${environment.apiUrl}/projectTasks`).pipe(map((response: any) => (<any>{
        result: state.take > 0 ? response.result.slice(0, state.take) : response,
        count: response.length
      })));
    }

    getSystemInformation(): Observable<Object>{
      return this.http.get(`${environment.apiUrl}/pmoSystemInformation`).pipe(catchError(this.handleError));
    }

    getpmoSystemInformationDetails(): Observable<Object>{
      return this.http.get(`${environment.apiUrl}/pmoSystemInformationDetails`).pipe(catchError(this.handleError));
    }

    getProjectTaskForCurrentUser(userId: number): Observable<Object>{
      return this.http.get(`${environment.apiUrl}/projectTasks?userId=${userId}`).pipe(catchError(this.handleError));
    }

    getProjectTaskForCurrentUserByProject(userId: number, projectId: number): Observable<Object>{
      return this.http.get(`${environment.apiUrl}/projectTasks?projectId=${projectId}&userId=${userId}`).pipe(catchError(this.handleError));
    }

    getProjectTaskByStatus(userId: number, projectId: number): Observable<Object>{
      return this.http.get(`${environment.apiUrl}/projectTasks?status=open&projectId=${projectId}&userId=${userId}`).pipe(catchError(this.handleError));
    }

//Project Task V2
  createProjectTasksV2(data: Object): Observable<Object> {
    return this.http.post(`${environment.apiUrl}/projectV2Tasks`, data).pipe(catchError(this.handleError));
  }

  createBulkProjectTasksV2(data: Object): Observable<Object> {
    return this.http.post(`${environment.apiUrl}/bulkProjectV2Tasks`, data).pipe(catchError(this.handleError));
  }

  updateProjectTasksV2(user: Object,id: number): Observable<Object> {
    return this.http.put(`${environment.apiUrl}/projectV2Tasks/${id}`, user).pipe(catchError(this.handleError));
  }

  deleteProjectTasksV2(id: number): Observable<Object> {
    return this.http.delete(`${environment.apiUrl}/projectV2Tasks/${id}`).pipe(catchError(this.handleError));
  }

  getProjectTaskForCurrentUserV2(userId: number): Observable<Object>{
    return this.http.get(`${environment.apiUrl}/projectV2Tasks?taskOwnerId=${userId}`).pipe(catchError(this.handleError));
  }

  getProjectTaskForCurrentUserByProjectV2(userId: number, projectId: number): Observable<Object>{
    return this.http.get(`${environment.apiUrl}/projectV2Tasks?projectV2Id=${projectId}&taskOwnerId=${userId}`).pipe(catchError(this.handleError));
  }

  //Get All projectTasks by Id
  getAllProjectTaskByProjectIdV2(projectId): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/projectV2Tasks?projectV2Id=${projectId}`).pipe(retry(2), catchError(this.handleError));
  }

  //Get projectResources by Id Get
  getProjectResourcesByProjectIdV2(projectId): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/projectV2Resources?projectV2Id=${projectId}`).pipe(retry(2), catchError(this.handleError));
  }

  getProjectV2ForTask(id: number) {
    return this.http.get(`${environment.apiUrl}/projectV2/${id}`).pipe(map(result => {
      return result;
    }), catchError(this.handleError));
  }

  getProjectTaskV2ByStatus(userId: number, projectId: number): Observable<Object>{
    return this.http.get(`${environment.apiUrl}/projectV2Tasks?status=open&projectV2Id=${projectId}&taskOwnerId=${userId}`).pipe(catchError(this.handleError));
  }

  // Get ProjectTasks by Id Get
  getProjectTasksV2ById(id: number): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/projectV2Tasks/${id}`).pipe(catchError(this.handleError));
  }
  
}
